import React from "react";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/checkInSaga";

const PeriodType = () => {
  const dispatch = useDispatch();
  const options = useSelector((state) => state.checkIn.periodTypeOptions);
  const selectedFilters = useSelector((state) => state.checkIn.selectedPeriodType);

  const periodTypeSettings = {
    filterType: "Custom Range",
    placeholder: "Select Period Type",
    numberDisplayed: 0,
    maxSelect: 1,
    enableMax: true,
    enableDefaultSelected: true,
    haveOnSelectChange: false,
    selectedFilters,
    options
  };

  const handleUpdateLocations = (data) => {
    dispatch(actionCreators.updatePeriodType(data));
  };

  const handleMaxSelected = (data) => {
    dispatch(actionCreators.maxSelected(data));
  };

  return (
    <MultiSelectDropdown
      {...periodTypeSettings}
      updateLocations={handleUpdateLocations}
      maxSelected={handleMaxSelected}
    />
  );
};

export default PeriodType;
